(() => {
  const CONDENSE_AFTER = 24;
  const MENU_TRANSITION_MS = 180;
  const SUBJECTS = ['Chemistry', 'Physics', 'Biology'];

  const SUBJECT_MENUS = [
    {
      key: 'a-level',
      navigationLabel: 'A Level',
      eyebrow: 'A Level',
      description: 'Select a subject, then your exam board.',
      quickLinks: ['All A Level decks', 'How Bolt works', 'Study guide'],
    },
    {
      key: 'gcse',
      navigationLabel: 'GCSE',
      eyebrow: 'GCSE',
      description: 'Select a subject, then your exam board.',
      quickLinks: ['All GCSE decks', 'How Bolt works', 'Study guide'],
    },
  ];

  const INTERNATIONAL_MENU = {
    key: 'international',
    navigationLabel: 'International',
    eyebrow: 'International',
    description: 'Select International GCSE or International A Level.',
    qualifications: ['International GCSE', 'International A Level'],
    quickLinks: ['All international decks', 'How Bolt works', 'Study guide'],
  };

  const INTERNATIONAL_BOARD_GROUPS = {
    'international gcse': [
      {
        heading: 'Cambridge IGCSE',
        linkPrefix: 'Cambridge IGCSE',
      },
      {
        heading: 'Pearson Edexcel International GCSE',
        linkPrefix: 'Pearson Edexcel International GCSE',
      },
    ],
    'international a level': [
      {
        heading: 'Cambridge International AS & A Level',
        linkPrefix: 'Cambridge International AS & A Level',
      },
      {
        heading: 'Pearson Edexcel IAL',
        linkPrefix: 'Pearson Edexcel International Advanced Level',
      },
    ],
  };

  let scheduled = false;
  let menuEnhancementScheduled = false;

  function getHeader() {
    return document.getElementById('header-component');
  }

  function refineWordmark(header) {
    const wordmark = header?.querySelector('.header-logo');
    if (!wordmark) return;

    wordmark.setAttribute('aria-label', 'Bolt Revision');
    wordmark.setAttribute('data-bolt-wordmark', '');
  }

  function normaliseLabel(value) {
    return value?.replace(/\s+/g, ' ').trim().toLocaleLowerCase() || '';
  }

  function slugify(value) {
    return normaliseLabel(value).replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function createTextElement(tag, className, text) {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text;
    return element;
  }

  function createIntroColumn(config) {
    const item = document.createElement('li');
    item.className = 'bolt-mega-menu__intro';
    item.append(
      createTextElement('p', 'bolt-mega-menu__eyebrow', config.eyebrow),
      createTextElement('p', 'bolt-mega-menu__title', 'Choose your deck'),
      createTextElement('p', 'bolt-mega-menu__description', config.description),
    );
    return item;
  }

  function createPlaceholderColumn(label, className) {
    const item = document.createElement('li');
    item.className = `mega-menu__column ${className} ${className}--${slugify(label)}`;
    item.dataset.boltStructuralPlaceholder = '';
    item.append(createTextElement('span', `${className}-heading`, label));
    return item;
  }

  function getTopLevelMenuTitle(item) {
    return item.querySelector(
      ':scope > .menu-list__trigger > .menu-list__link .menu-list__link-title, :scope > .menu-list__link .menu-list__link-title',
    )?.textContent;
  }

  function getColumnHeading(column) {
    return column.querySelector(':scope > div > .mega-menu__link--parent')?.textContent;
  }

  function getMenuContext(header, navigationLabel) {
    const menuItem = [...header.querySelectorAll('.menu-list__list-item')].find(
      (item) => normaliseLabel(getTopLevelMenuTitle(item)) === normaliseLabel(navigationLabel),
    );
    const submenu = menuItem?.querySelector(':scope > .menu-list__submenu');
    const list = submenu?.querySelector('.mega-menu__list');

    return { menuItem, submenu, list };
  }

  function collectQuickLinkContainers(list, labels) {
    const expected = new Set(labels.map(normaliseLabel));
    const containers = [];

    for (const column of [...list.querySelectorAll(':scope > .mega-menu__column')]) {
      for (const container of [...column.querySelectorAll(':scope > div')]) {
        const link = container.querySelector(':scope > .mega-menu__link:not(.mega-menu__link--parent)');
        if (link && expected.has(normaliseLabel(link.textContent))) containers.push(container);
      }
    }

    return containers;
  }

  function appendQuickLinksColumn(list, containers) {
    const quickLinks = document.createElement('li');
    quickLinks.className = 'mega-menu__column bolt-mega-menu__quick-links';
    quickLinks.append(createTextElement('span', 'bolt-mega-menu__quick-heading', 'Quick links'));
    quickLinks.append(...containers);
    list.append(quickLinks);
  }

  function removeEmptyColumns(list) {
    for (const column of [...list.querySelectorAll(':scope > .mega-menu__column')]) {
      if (!column.children.length) column.remove();
    }
  }

  function enhanceCourseCodeLabels(column) {
    for (const link of [...column.querySelectorAll(':scope > div > ul .mega-menu__link')]) {
      if (link.dataset.boltCourseCodeEnhanced === 'true') continue;

      const fullLabel = link.textContent.replace(/\s+/g, ' ').trim();
      const match = fullLabel.match(/^(.+?)\s*\(([A-Z0-9]+)\)$/i);
      if (!match) continue;

      link.dataset.boltCourseCodeEnhanced = 'true';
      link.setAttribute('aria-label', fullLabel);
      link.textContent = '';
      link.append(
        document.createTextNode(match[1].trim()),
        createTextElement('span', 'bolt-mega-menu__course-code', match[2]),
      );
    }
  }

  function groupInternationalBoardLinks(column, qualification) {
    const linksList = column.querySelector(':scope > div > ul');
    const boardGroups = INTERNATIONAL_BOARD_GROUPS[normaliseLabel(qualification)];
    if (!linksList || !boardGroups) return;

    const links = [...linksList.querySelectorAll(':scope > li > .mega-menu__link')];

    for (const board of boardGroups) {
      const prefix = `${normaliseLabel(board.linkPrefix)} `;
      const matches = links.filter((link) => normaliseLabel(link.textContent).startsWith(prefix));
      if (!matches.length) continue;

      const headingItem = document.createElement('li');
      headingItem.className = 'bolt-mega-menu__board-heading';
      headingItem.append(createTextElement('span', 'bolt-mega-menu__board-label', board.heading));
      matches[0].closest('li')?.before(headingItem);

      for (const link of matches) {
        const fullLabel = link.textContent.replace(/\s+/g, ' ').trim();
        link.setAttribute('aria-label', fullLabel);
        link.textContent = fullLabel.slice(board.linkPrefix.length).trim();
      }
    }
  }

  function bindMenuTransition(menuItem, submenu) {
    if (submenu.dataset.boltTransitionBound === 'true') return;

    const disclosure = menuItem.querySelector(':scope > .menu-list__trigger > .menu-list__disclosure');
    if (!disclosure) return;

    submenu.dataset.boltTransitionBound = 'true';
    let wasOpen = disclosure.getAttribute('aria-expanded') === 'true';
    let closeTimer;

    const sync = () => {
      const isOpen = disclosure.getAttribute('aria-expanded') === 'true';
      window.clearTimeout(closeTimer);

      if (isOpen) {
        submenu.dataset.boltOpen = '';
        delete submenu.dataset.boltClosing;
      } else {
        delete submenu.dataset.boltOpen;
        if (wasOpen) {
          submenu.dataset.boltClosing = '';
          closeTimer = window.setTimeout(() => {
            delete submenu.dataset.boltClosing;
          }, MENU_TRANSITION_MS);
        }
      }

      wasOpen = isOpen;
    };

    new MutationObserver(sync).observe(disclosure, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });
    sync();
  }

  function enhanceSubjectMegaMenu(header, config) {
    const { menuItem, submenu, list } = getMenuContext(header, config.navigationLabel);
    if (!menuItem || !submenu || !list || list.dataset.boltEnhanced === 'true') return;

    submenu.classList.add('bolt-mega-menu--academic', `bolt-mega-menu--${config.key}`);
    list.classList.add('bolt-mega-menu__list');
    list.dataset.boltEnhanced = 'true';
    list.prepend(createIntroColumn(config));

    const subjectColumns = new Map();

    for (const column of [...list.querySelectorAll(':scope > .mega-menu__column')]) {
      const heading = normaliseLabel(getColumnHeading(column));
      const subject = SUBJECTS.find((name) => normaliseLabel(name) === heading);

      if (subject) {
        column.classList.add('bolt-mega-menu__subject', `bolt-mega-menu__subject--${slugify(subject)}`);
        enhanceCourseCodeLabels(column);
        subjectColumns.set(heading, column);
      }
    }

    for (const subject of SUBJECTS) {
      const key = normaliseLabel(subject);
      if (!subjectColumns.has(key)) {
        const placeholder = createPlaceholderColumn(subject, 'bolt-mega-menu__subject');
        list.append(placeholder);
        subjectColumns.set(key, placeholder);
      }
    }

    appendQuickLinksColumn(list, collectQuickLinkContainers(list, config.quickLinks));
    removeEmptyColumns(list);
    bindMenuTransition(menuItem, submenu);
  }

  function enhanceInternationalMegaMenu(header) {
    const config = INTERNATIONAL_MENU;
    const { menuItem, submenu, list } = getMenuContext(header, config.navigationLabel);
    if (!menuItem || !submenu || !list || list.dataset.boltEnhanced === 'true') return;

    submenu.classList.add('bolt-mega-menu--international');
    list.classList.add('bolt-mega-menu__list', 'bolt-mega-menu__list--international');
    list.dataset.boltEnhanced = 'true';
    list.prepend(createIntroColumn(config));

    const qualificationColumns = new Map();

    for (const column of [...list.querySelectorAll(':scope > .mega-menu__column')]) {
      const heading = normaliseLabel(getColumnHeading(column));
      const qualification = config.qualifications.find((name) => normaliseLabel(name) === heading);

      if (qualification) {
        column.classList.add(
          'bolt-mega-menu__qualification',
          `bolt-mega-menu__qualification--${slugify(qualification)}`,
        );
        groupInternationalBoardLinks(column, qualification);
        qualificationColumns.set(heading, column);
      }
    }

    for (const qualification of config.qualifications) {
      const key = normaliseLabel(qualification);
      if (!qualificationColumns.has(key)) {
        const placeholder = createPlaceholderColumn(qualification, 'bolt-mega-menu__qualification');
        list.append(placeholder);
        qualificationColumns.set(key, placeholder);
      }
    }

    appendQuickLinksColumn(list, collectQuickLinkContainers(list, config.quickLinks));
    removeEmptyColumns(list);
    bindMenuTransition(menuItem, submenu);
  }

  function enhanceMegaMenus(header) {
    for (const config of SUBJECT_MENUS) enhanceSubjectMegaMenu(header, config);
    enhanceInternationalMegaMenu(header);
  }

  function scheduleMenuEnhancement(header) {
    if (menuEnhancementScheduled) return;
    menuEnhancementScheduled = true;
    window.requestAnimationFrame(() => {
      menuEnhancementScheduled = false;
      enhanceMegaMenus(header);
    });
  }

  function observeMenuHydration(header) {
    if (header.dataset.boltMenuObserved === 'true') return;
    header.dataset.boltMenuObserved = 'true';

    new MutationObserver(() => scheduleMenuEnhancement(header)).observe(header, {
      childList: true,
      subtree: true,
    });
  }

  function updateHeaderState() {
    scheduled = false;
    const header = getHeader();
    if (!header) return;

    header.dataset.boltCondensed = String(window.scrollY > CONDENSE_AFTER);
  }

  function scheduleHeaderUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateHeaderState);
  }

  function initialiseHeader() {
    const header = getHeader();
    if (!header) return;

    header.setAttribute('data-bolt-header', '');
    refineWordmark(header);
    enhanceMegaMenus(header);
    observeMenuHydration(header);
    updateHeaderState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseHeader, { once: true });
  } else {
    initialiseHeader();
  }

  window.addEventListener('scroll', scheduleHeaderUpdate, { passive: true });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector?.('#header-component') || event.target.id === 'header-component') {
      initialiseHeader();
    }
  });
})();
